import React from "react";
import styled from "styled-components";
import { ProjectContainer, ProjectTitle, ProjectInfo } from "./styles";
import { useLanguage } from "../../contexts/LanguageContext";

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;

  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }

  .seeDemo {
    text-align: center;
    margin: 20px 0;

    a {
      background: #f34452;
      color: #fff;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      display: inline-block;

      &:hover {
        background: #d63946;
      }
    }
  }

  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    li {
      b {
        color: #333;
      }
    }
  }

  .closeBtn {
    text-align: center;
    margin-top: 30px;

    button {
      background: #007bff;
      color: #fff;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;

      &:hover {
        background: #0056b3;
      }

      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectDataProductProps {}

const ProjectDataProduct: React.FC<ProjectDataProductProps> = () => {
  const { t } = useLanguage();

  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t("dataproduct.title")}</h2>
        <p className="tags">{t("dataproduct.role")}</p>
      </ProjectTitle>

      <ProjectDescription>{t("dataproduct.description")}</ProjectDescription>

      <ProjectInfo>
        <p>
          <b>{t("dataproduct.roleLabel")}</b> {t("dataproduct.myRole")}
        </p>
        <p>
          <b>{t("dataproduct.skillsLabel")}</b>{" "}
          {t("dataproduct.skillsUtilized")}
        </p>
      </ProjectInfo>

      <ProjectWrapper>
        <img loading="lazy" decoding="async"
          src="/images/portfolio/p8-dataproduct-min.webp"
          className="img-responsive"
          alt="data product design"
        />
        <img loading="lazy" decoding="async"
          src="/images/projects/data-00-min.webp"
          className="img-responsive"
          alt="data product design"
        />
        <img loading="lazy" decoding="async"
          src="/images/projects/data-001-min.webp"
          className="img-responsive"
          alt="data product design"
        />
        <img loading="lazy" decoding="async"
          src="/images/projects/data-002-min.webp"
          className="img-responsive"
          alt="data product design"
        />
        <img loading="lazy" decoding="async"
          src="/images/projects/data-01-min.webp"
          className="img-responsive"
          alt="data product design"
        />
        <img loading="lazy" decoding="async"
          src="/images/projects/data-03-min.webp"
          className="img-responsive"
          alt="data product design"
        />
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li>
            <b>{t("dataproduct.dateLabel")}</b> {t("dataproduct.dateRange")}
          </li>
          <li>
            <b>{t("dataproduct.teamMembersLabel")}</b>{" "}
            {t("dataproduct.teamMembers")}
          </li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectDataProduct;
